var exports = {
  "x": "xaf9ae18d--daa38d--button",
};

module.exports = exports;
